import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateMarkingList } from '../reduxToolkit/redux';
import './Detail_omrTec.scss';
import Button from '@mui/material/Button';
import axios from 'axios';
import fnc from '../mymod/commFunction';
import ComboboxMui from '../comm/ComboboxMui';
import OmrSubmissionResultsModal from './OmrSubmissionResultsModal';
import KatexText from './KatexText';
import { submitBilledAi, billingError } from '../billing/billingClient';

const createEmptyCriterion = () => ({
    text: '',
    valueType: 'score',
    value: ''
});

const AI_CREDIT_NOTICE = 'AI 판독 시 선생님 본인의 크레딧이 사용됩니다. 실행 전에 예상 사용량을 확인합니다.';
const AI_IMAGE_UPLOAD_ERROR = 'AI 판독은 완료되었지만 원본 이미지 저장에 실패했습니다. 사용 크레딧은 AI 지갑에서 확인해 주세요. 같은 이미지를 다시 선택해 저장을 재시도해 주세요.';

const createEmptyModelAnswerSheet = () => ({
    imageKey: '',
    imageName: '',
    previewUrl: '',
    status: 'idle',
    error: '',
    confidence: null,
    warnings: []
});

const normalizeDbText = (value) => {
    const text = value == null ? '' : String(value);
    return text.trim().toUpperCase() === 'NULL' ? '' : text;
};

const formatShortAnswerForKatex = (value) => {
    const source = String(value ?? '').trim();
    if (!source || source.includes('$')) return source;
    const looksLikeMath = /[0-9\\^_{}=+\-*/<>≤≥°π√]/.test(source);
    if (!looksLikeMath) return source;
    return `$${source.replace(/°/g, '^{\\circ}')}$`;
};

const fileToDataUrl = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(new Error('이미지를 읽지 못했습니다.'));
    reader.readAsDataURL(file);
});

const prepareFullSheetImage = async (file) => {
    if (file.size > 20 * 1024 * 1024) {
      throw new Error('전체 모범답안 이미지는 원본 기준 20MB 이하만 사용할 수 있습니다.');
    }
    const image = await new Promise((resolve, reject) => {
      const previewUrl = URL.createObjectURL(file);
      const element = new Image();
      element.onload = () => {
        URL.revokeObjectURL(previewUrl);
        resolve(element);
      };
      element.onerror = () => {
        URL.revokeObjectURL(previewUrl);
        reject(new Error('전체 모범답안 이미지를 읽지 못했습니다.'));
      };
      element.src = previewUrl;
    });
    const maxEdge = 3200;
    const longEdge = Math.max(image.naturalWidth, image.naturalHeight);
    if (longEdge <= maxEdge && file.size <= 6 * 1024 * 1024) return file;

    const scale = Math.min(1, maxEdge / longEdge);
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
    canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
    const context = canvas.getContext('2d');
    if (!context) throw new Error('이 브라우저에서는 이미지를 처리할 수 없습니다.');
    context.fillStyle = '#fff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = 'high';
    context.drawImage(image, 0, 0, canvas.width, canvas.height);

    const toBlob = (quality) => new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (blob) resolve(blob);
        else reject(new Error('이미지 크기를 줄이지 못했습니다.'));
      }, 'image/jpeg', quality);
    });
    let blob = await toBlob(0.9);
    if (blob.size > 6 * 1024 * 1024) blob = await toBlob(0.8);
    if (blob.size > 6 * 1024 * 1024) blob = await toBlob(0.7);
    if (blob.size > 6 * 1024 * 1024) {
      throw new Error('전체 모범답안 이미지를 6MB 이하로 줄이지 못했습니다.');
    }
    const baseName = String(file.name || 'model-answer-sheet').replace(/\.[^.]+$/, '');
    return new File([blob], `${baseName}.jpg`, { type: 'image/jpeg', lastModified: Date.now() });
};

const Detail_omrTec = () => { 
    const dispatch = useDispatch();
    // const markingList = useSelector(state => state.reduxStore.markingList);
    // const list = useSelector(state => state.reduxStore.list_pdf_marking);
    const [selectedValues, setSelectedValues] = useState({});
    const [questionCount, setQuestionCount] = useState(null); // 문항 수를 상태로 관리
    const [list, setList] = useState([]);
    const [markingList, setMarkingList] = useState({});
    const lmsListCode = useSelector(state => state.reduxStore.lmsListCode);//prentCode
    const [isRefresh, setIsRefresh] = useState(false);
    const [pointSum, setPointSum] = useState(0);
    const [isSubmissionModalOpen, setIsSubmissionModalOpen] = useState(false);
    const [modelAnswerSheet, setModelAnswerSheet] = useState(createEmptyModelAnswerSheet);

    useEffect(() => {
        // const initialValues = list.map(item => ({...item, analysisItem: item.analysisItem || '' })); // 초기값 설정  
        // setList(initialValues);

        fncSelect_list();
      }, [isRefresh]);

      
    useEffect(() => {
        if (markingList) {
            setSelectedValues(markingList);
        }
    }, [markingList]);

    const handleRadioChange = (idx, value) => {
        const updatedValues = {
            ...selectedValues,
            [idx + 1]: value
        };
        setSelectedValues(updatedValues);
    };

     
  function fncSelect_list() {
    const acaCode = fnc.getCookie('acaCode');

    fnc.sendAxios('/select/lmsTec/course/testMakeOmr', { acaCode, parentCode: lmsListCode }, (res) => {
      if (res && Array.isArray(res)) { 
        const fetchedList = getRecords(res);
        setList(fetchedList);
        setQuestionCount(fetchedList.length);
        setPointSum(fetchedList.reduce((sum, item) => sum + (parseFloat(item.point) || 0), 0));
        const initialValues = {};
        fetchedList.forEach(item => {
            initialValues[item.munNo] = item.dap;
        });
        setSelectedValues(initialValues);
        fncSelectRubrics(fetchedList);
        fncSelectModelAnswerSheet();

      } else {
        console.log(res,"kuesbLmsTecRoutes/select/lmsTec/course/testMakeOmr");
      }
    });
  }

  function fncSelectRubrics(fetchedList) {
    const acaCode = fnc.getCookie('acaCode');

    fnc.sendAxios('/select/lmsTec/course/omrRubrics', { acaCode, parentCode: lmsListCode }, (res) => {
      if (!Array.isArray(res)) return;

      const questionSettingMap = res.reduce((map, row) => {
        const munNo = Number(row.munNo);
        if (!map[munNo]) {
          map[munNo] = {
            questionType: ['objective', 'shortAnswer', 'subjective'].includes(row.questionType)
              ? row.questionType
              : 'subjective',
            criteria: [],
            modelAnswerText: normalizeDbText(row.modelAnswerText),
            modelAnswerImageKey: normalizeDbText(row.modelAnswerImageKey),
            modelAnswerImageName: normalizeDbText(row.modelAnswerImageName)
          };
        }
        if (Number(row.criterionNo) > 0) {
          map[munNo].criteria.push({
            text: row.criterionText || '',
            valueType: row.valueType === 'ratio' ? 'ratio' : 'score',
            value: row.criterionValue == null ? '' : String(row.criterionValue)
          });
        }
        return map;
      }, {});

      const mergedList = fetchedList.map((item) => {
        const setting = questionSettingMap[Number(item.munNo)];
        const hasSubjectiveSetting = Boolean(
          setting?.criteria?.length || String(setting?.modelAnswerText || '').trim()
        );
        const questionType = (
          item.questionType === 'objective'
          && setting?.questionType === 'subjective'
          && !hasSubjectiveSetting
        ) ? 'objective' : (setting?.questionType || 'objective');
        return {
          ...item,
          questionType,
          criteria: setting ? setting.criteria : [],
          modelAnswerText: setting ? setting.modelAnswerText : '',
          modelAnswerImageKey: setting ? setting.modelAnswerImageKey : '',
          modelAnswerImageName: setting ? setting.modelAnswerImageName : '',
          modelAnswerPreview: '',
          modelAnswerStatus: 'idle',
          modelAnswerError: '',
          isModelAnswerEditing: false
        };
      });

      Promise.all(mergedList.map(async (item) => {
        if (!item.modelAnswerImageKey) return item;
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_SERVER_URL || ''}/get-image-path`,
            { imagePath: item.modelAnswerImageKey, sec: 3600 }
          );
          return { ...item, modelAnswerPreview: response.data?.url || '' };
        } catch (error) {
          return { ...item, modelAnswerError: '저장된 모범 답안 이미지를 불러오지 못했습니다.' };
        }
      })).then(setList);
    });
  }

  function fncSelectModelAnswerSheet() {
    const acaCode = fnc.getCookie('acaCode');
    fnc.sendAxios('/select/lmsTec/course/omrAnswerSheet', { acaCode, parentCode: lmsListCode }, async (res) => {
      const row = Array.isArray(res) ? res[0] : null;
      const imageKey = normalizeDbText(row?.imageKey);
      const imageName = normalizeDbText(row?.imageName);
      if (!imageKey) {
        setModelAnswerSheet(createEmptyModelAnswerSheet());
        return;
      }

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_SERVER_URL || ''}/get-image-path`,
          { imagePath: imageKey, sec: 3600 }
        );
        setModelAnswerSheet({
          imageKey,
          imageName,
          previewUrl: response.data?.url || '',
          status: 'success',
          error: '',
          confidence: null,
          warnings: []
        });
      } catch (error) {
        setModelAnswerSheet({
          imageKey,
          imageName,
          previewUrl: '',
          status: 'error',
          error: '저장된 전체 모범답안 이미지를 불러오지 못했습니다.',
          confidence: null,
          warnings: []
        });
      }
    });
  }



  
  function getRecords(res) {
    let records = [];
    for (let i = 0; i < res.length; i++) {      
        const sno= res[i]["sno"];
        const munNo= res[i]["munNo"];//list 코드 parent Code로 사용
        const dap = res[i]["dap"];
        //pointsValue = list[i].point ?? ' '; 저장할 때 ''이면 저장이 안 돼서
        const point = (res[i]["point"] ?? '').trim();
        const analysisItem = (res[i]["analysisItem"] ?? '').trim();
        //아래가 제일 안전해
        //const point = ['2', '3', '4'].includes(res[i]["point"]) ? res[i]["point"] : ''; // Validates against available options
        //const analysisItem = ['a1', 'a2', 'a3', 'a4'].includes(res[i]["analysisItem"]) ? res[i]["analysisItem"] : '';    
   
        records.push({
          sno,
          munNo,
          dap,
          point,
          analysisItem,
          questionType: 'objective',
          criteria: [],
          modelAnswerText: '',
          modelAnswerImageKey: '',
          modelAnswerImageName: '',
          modelAnswerPreview: '',
          modelAnswerStatus: 'idle',
          modelAnswerError: '',
          isModelAnswerEditing: false
        });
    }
    return records;
  }


  
  function fncSaveRecord() {
 
    const rtn = window.confirm('OMR을 저장하시겠습니까?');
    if(!rtn) return;

    if (modelAnswerSheet.status === 'uploading' || modelAnswerSheet.status === 'analyzing') {
      alert('전체 모범답안 이미지 판독이 끝날 때까지 기다려 주세요.');
      return;
    }

    for (let questionIndex = 0; questionIndex < list.length; questionIndex++) {
      const item = list[questionIndex];
      if (
        item.questionType === 'shortAnswer'
        && !String(selectedValues[questionIndex + 1] || '').trim()
        && !modelAnswerSheet.imageKey
      ) {
        alert(`${questionIndex + 1}번 문항의 단답형 정답을 입력하세요.`);
        return;
      }
      if (item.questionType !== 'subjective') continue;

      if (item.modelAnswerStatus === 'converting' || item.modelAnswerStatus === 'uploading') {
        alert(`${questionIndex + 1}번 문항의 모범 답안 변환이 끝날 때까지 기다려 주세요.`);
        return;
      }
      if (!String(item.modelAnswerText || '').trim() && !modelAnswerSheet.imageKey) {
        if (item.modelAnswerPreview) {
          alert(
            `${questionIndex + 1}번 문항의 모범 답안 이미지가 KaTeX로 변환되지 않았습니다.\n` +
            `${item.modelAnswerError || 'LMS API와 수식 변환 설정을 확인한 후 이미지를 다시 붙여 넣어 주세요.'}`
          );
        } else {
          alert(`${questionIndex + 1}번 문항에 모범 답안 이미지를 붙여 넣거나 모범 답안을 직접 입력하세요.`);
        }
        return;
      }
      if (item.modelAnswerPreview && !item.modelAnswerImageKey) {
        alert(`${questionIndex + 1}번 문항의 모범 답안 이미지가 저장되지 않았습니다. 이미지를 다시 붙여 넣어 주세요.`);
        return;
      }

      const criteria = item.criteria || [];
      for (let criterionIndex = 0; criterionIndex < criteria.length; criterionIndex++) {
        const criterion = criteria[criterionIndex];
        const numericValue = Number(criterion.value);
        if (!criterion.text.trim()) {
          alert(`${questionIndex + 1}번 문항의 채점 기준을 입력하세요.`);
          return;
        }
        if (criterion.value === '' || !Number.isFinite(numericValue) || numericValue <= 0) {
          alert(`${questionIndex + 1}번 문항의 점수 또는 배율을 올바르게 입력하세요.`);
          return;
        }
      }
    }

    // 빈 값도 하나의 문항으로 처리되도록 공백을 넣어 위치를 유지한다.
    // 기존처럼 누적 문자열의 truthy 여부로 '@'를 붙이면,
    // 저장된 빈 값('')을 다시 저장할 때 문항 구분자가 사라진다.
    const preserveEmptyPosition = (value) => {
        const normalizedValue = value == null ? '' : String(value);
        return normalizedValue === '' ? ' ' : normalizedValue;
    };

    const markingBar = list
        .map((item, index) => preserveEmptyPosition(
          item.questionType === 'subjective' ? '' : selectedValues[index + 1]
        ))
        .join('@');
    const pointsBar = list
        .map(item => preserveEmptyPosition(item.point))
        .join('@');
    const analysisItemsBar = list
        .map(item => preserveEmptyPosition(item.analysisItem))
        .join('@');

    // console.log(lmsListCode, markingBar, pointsBar, analysisItemsBar, analysisItemsBar);
    fncInsert_usp_markingOmrTec(lmsListCode, markingBar, pointsBar, analysisItemsBar);

  };


function fncInsert_usp_markingOmrTec(parentCode, dataString, pointsBar, analysisItemsBar) {
    const acaCode = fnc.getCookie('acaCode');
    
    fnc.sendAxios('/insert/lmsTec/omr/usp_markingOmrTec', { acaCode, parentCode, dataString, pointsBar, analysisItemsBar }, (res) => {
      if (res && res.success && res.result === 'Y') {
          fncSaveRubrics(acaCode, parentCode);
      } else {
        console.log(res,"kuesbLmsTecRoutes/insert/lmsTec/omr/usp_markingOmrTec");
        alert('OMR 저장에 실패했습니다.');
      }
    });
  }

  function fncSaveRubrics(acaCode, parentCode) {
    const rubrics = list
      .map((item, index) => ({
        munNo: index + 1,
        questionType: item.questionType || 'objective',
        criteria: item.criteria || [],
        modelAnswerText: item.modelAnswerText || '',
        modelAnswerImageKey: item.modelAnswerImageKey || '',
        modelAnswerImageName: item.modelAnswerImageName || ''
      }));

    fnc.sendAxios('/save/lmsTec/course/omrRubrics', {
      acaCode,
      parentCode,
      rubrics,
      modelAnswerSheet: {
        imageKey: modelAnswerSheet.imageKey || '',
        imageName: modelAnswerSheet.imageName || ''
      }
    }, (res) => {
      if (res && res.success) {
        setIsRefresh(current => !current);
        alert('저장이 완료되었습니다.');
      } else {
        console.log(res, 'save/lmsTec/course/omrRubrics');
        alert('채점 기준 저장에 실패했습니다.');
      }
    });
  }


  function onMakeOmr() {
    if (!questionCount) {
      alert('문항수를 입력하세요!');
      return;
    }
    const newList = Array.from({ length: questionCount }, (_, index) => ({
      id: index + 1,
      questionType: 'objective',
      criteria: [],
      modelAnswerText: '',
      modelAnswerImageKey: '',
      modelAnswerImageName: '',
      modelAnswerPreview: '',
      modelAnswerStatus: 'idle',
      modelAnswerError: '',
      isModelAnswerEditing: false
    }));
    setList(newList);

  }

  function handleMunCntChange(e) {
    const newCount = e.target.value;
    // Allow backspace (empty input) or valid positive numbers
    if (newCount === '' || (!isNaN(newCount) && newCount > 0)) {
      setQuestionCount(newCount);
    }

  }

  function onSave() {
    fncSaveRecord();
  }

  function onDelete() {
    const acaCode = fnc.getCookie('acaCode');
    const parentCode = lmsListCode;

    const rtn = window.confirm('OMR을 삭제하시겠습니까?');
    if(!rtn) return;

    fnc.sendAxios('/delete/lmsTec/course/markingOmrTec', { acaCode, parentCode }, (res) => {
      if (res) { 
        setIsRefresh(!isRefresh);
        setQuestionCount(null);
      } else {
        console.log(res,"delete/lmsTec/course/markingOmrTec");
      }
    });

  }

  function onRefresh() {
    setIsRefresh(!isRefresh);
  }

  
  const optionData = [
    { value: '', label: '배점을 선택를 선택하세요' },
    { value: '2', label: '2점' },
    { value: '3', label: '3점' },
    { value: '4', label: '4점' },
    { value: '5', label: '5점' },
    { value: '10', label: '10점' },
  ];

  const optionData_analysis = [
    { value: '', label: '항목을 선택를 선택하세요' },
    { value: 'a1', label: '계산력' },
    { value: 'a2', label: '이해력' },
    { value: 'a3', label: '적용력' },
    { value: 'a4', label: '추론력' },
    { value: 'a5', label: '해결력' },
  ];

  const optionData_questionType = [
    { value: 'objective', label: '객관식' },
    { value: 'shortAnswer', label: '단답형' },
    { value: 'subjective', label: '서술형' },
  ];

  const optionData_valueType = [
    { value: 'score', label: '점수' },
    { value: 'ratio', label: '배율' },
  ];

  
  const handleOptionChange = (event, index) => {
    const newList = [...list];
    newList[index].point = event.target.value;
    setList(newList);
    // point의 합계 계산
    const totalPoints = newList.reduce((sum, item) => sum + (parseFloat(item.point) || 0), 0);
    // 합계를 setPointSum에 설정
    setPointSum(totalPoints);
  };

  const handleSetAllPoints = (point) => {
    const updatedList = list.map(item => ({ ...item, point }));
    setList(updatedList);
    const totalPoints = updatedList.reduce((sum, item) => sum + (parseFloat(item.point) || 0), 0);
    setPointSum(totalPoints);
  };



const handleOptionChange_analysis = (event, index) => {
    const newList = [...list];
    newList[index].analysisItem = event.target.value;
    setList(newList);
};

const handleQuestionTypeChange = (event, index) => {
    const questionType = event.target.value;
    const newList = [...list];
    newList[index] = {
      ...newList[index],
      questionType,
      criteria: questionType === 'subjective' && !(newList[index].criteria || []).length
        ? [createEmptyCriterion()]
        : (newList[index].criteria || [])
    };
    setList(newList);
};

const handleCriterionChange = (questionIndex, criterionIndex, field, value) => {
    const newList = [...list];
    const criteria = [...(newList[questionIndex].criteria || [])];
    criteria[criterionIndex] = { ...criteria[criterionIndex], [field]: value };
    newList[questionIndex] = { ...newList[questionIndex], criteria };
    setList(newList);
};

const addCriterion = (questionIndex) => {
    const newList = [...list];
    newList[questionIndex] = {
      ...newList[questionIndex],
      criteria: [...(newList[questionIndex].criteria || []), createEmptyCriterion()]
    };
    setList(newList);
};

const removeCriterion = (questionIndex, criterionIndex) => {
    const newList = [...list];
    const criteria = (newList[questionIndex].criteria || []).filter((_, index) => index !== criterionIndex);
    newList[questionIndex] = {
      ...newList[questionIndex],
      criteria: criteria.length ? criteria : [createEmptyCriterion()]
    };
    setList(newList);
};

const updateModelAnswer = (questionIndex, patch) => {
    setList((current) => current.map((item, index) => (
      index === questionIndex ? { ...item, ...patch } : item
    )));
};

const convertModelAnswerImage = async (questionIndex, file) => {
    if (!file || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
      updateModelAnswer(questionIndex, { modelAnswerError: 'JPG, PNG 또는 WEBP 이미지를 사용하세요.' });
      return;
    }
    if (file.size > 3 * 1024 * 1024) {
      updateModelAnswer(questionIndex, { modelAnswerError: '모범 답안 이미지는 3MB 이하만 사용할 수 있습니다.' });
      return;
    }

    let aiCompleted = false;
    try {
      const dataUrl = await fileToDataUrl(file);
      const previewUrl = URL.createObjectURL(file);
      updateModelAnswer(questionIndex, {
        modelAnswerPreview: previewUrl,
        modelAnswerStatus: 'converting',
        modelAnswerError: '',
        modelAnswerConfidence: null
      });

      const response = await submitBilledAi(
        '/convert/lmsTec/omrModelAnswer', 'teacher_omr_extract',
        { image: dataUrl.split(',')[1], type: file.type },
        { timeout: 100000 }
      );
      aiCompleted = true;
      const katexText = response.data?.katexText || '';
      const modelAnswerConfidence = Math.round((Number(response.data?.confidence) || 0) * 100);
      updateModelAnswer(questionIndex, {
        modelAnswerText: katexText,
        modelAnswerImageKey: '',
        modelAnswerImageName: '',
        modelAnswerStatus: 'uploading',
        modelAnswerError: '',
        modelAnswerConfidence,
        isModelAnswerEditing: false
      });

      const acaCode = fnc.getCookie('acaCode');
      const safeParentCode = String(lmsListCode || 'omr').replace(/[^a-zA-Z0-9_-]/g, '_');
      const extensionByType = {
        'image/jpeg': 'jpg',
        'image/png': 'png',
        'image/webp': 'webp'
      };
      const extension = extensionByType[file.type] || 'png';
      const storedFileName = `model-answer-q${questionIndex + 1}-${Date.now()}.${extension}`;
      const folder = `web/kuesbLmsOmr/model-answer/${acaCode}/${safeParentCode}`;
      const uploadResponse = await axios.post(
        `${process.env.REACT_APP_SERVER_URL || ''}/generate-upload-url`,
        { fileName: storedFileName, fileType: file.type, folder, sec: 600 }
      );
      if (!uploadResponse.data?.url || !uploadResponse.data?.key) {
        throw new Error('모범 답안 이미지 저장 경로를 만들지 못했습니다.');
      }
      await axios.put(uploadResponse.data.url, file, {
        headers: { 'Content-Type': file.type },
        timeout: 100000
      });
      updateModelAnswer(questionIndex, {
        modelAnswerText: katexText,
        modelAnswerImageKey: uploadResponse.data.key,
        modelAnswerImageName: file.name || storedFileName,
        modelAnswerStatus: 'success',
        modelAnswerError: '',
        modelAnswerConfidence,
        isModelAnswerEditing: false
      });
    } catch (error) {
      updateModelAnswer(questionIndex, {
        modelAnswerStatus: aiCompleted ? 'uploadError' : 'error',
        modelAnswerError: aiCompleted ? AI_IMAGE_UPLOAD_ERROR : billingError(error)
      });
    }
};

const handleModelAnswerPaste = (questionIndex, event) => {
    const imageItem = Array.from(event.clipboardData?.items || [])
      .find((item) => item.kind === 'file' && item.type.startsWith('image/'));
    if (!imageItem) return;

    event.preventDefault();
    const confirmed = window.confirm(
      `${questionIndex + 1}번 모범 답안 이미지를 붙여 넣으면 현재 모범 답안이 AI 변환 결과로 바뀝니다.\n자동으로 되돌릴 수 없습니다. 계속하시겠습니까?`
    );
    if (!confirmed) return;
    convertModelAnswerImage(questionIndex, imageItem.getAsFile());
};

const handleModelAnswerFile = (questionIndex, event) => {
    const input = event.currentTarget;
    const file = input.files?.[0];
    input.value = '';
    if (file) convertModelAnswerImage(questionIndex, file);
};

const clearModelAnswer = (questionIndex) => {
    updateModelAnswer(questionIndex, {
      modelAnswerText: '',
      modelAnswerImageKey: '',
      modelAnswerImageName: '',
      modelAnswerPreview: '',
      modelAnswerStatus: 'idle',
      modelAnswerError: '',
      modelAnswerConfidence: null,
      isModelAnswerEditing: false
    });
};

const applyModelAnswerSheetQuestions = (parsedQuestions) => {
    const validQuestions = (Array.isArray(parsedQuestions) ? parsedQuestions : [])
      .filter((item) => Number.isInteger(Number(item.questionNo)) && Number(item.questionNo) > 0);
    if (!validQuestions.length) throw new Error('판독된 문항이 없습니다.');

    const questionMap = new Map(validQuestions.map((item) => [Number(item.questionNo), item]));
    const nextQuestionCount = Math.max(...questionMap.keys());
    const nextSelectedValues = {};
    const nextList = Array.from({ length: nextQuestionCount }, (_, index) => {
      const munNo = index + 1;
      const parsed = questionMap.get(munNo);
      const previous = list[index] || {};
      if (!parsed) {
        nextSelectedValues[munNo] = selectedValues[munNo] || '';
        return {
          ...previous,
          id: previous.id || munNo,
          munNo,
          questionType: previous.questionType || 'objective',
          criteria: previous.criteria || [],
          modelAnswerText: previous.modelAnswerText || '',
          modelAnswerImageKey: previous.modelAnswerImageKey || '',
          modelAnswerImageName: previous.modelAnswerImageName || '',
          modelAnswerPreview: previous.modelAnswerPreview || '',
          modelAnswerStatus: previous.modelAnswerStatus || 'idle',
          modelAnswerError: previous.modelAnswerError || '',
          isModelAnswerEditing: false
        };
      }

      const questionType = ['objective', 'shortAnswer', 'subjective'].includes(parsed.questionType)
        ? parsed.questionType
        : 'objective';
      nextSelectedValues[munNo] = questionType === 'subjective' ? '' : String(parsed.answer || '');
      const criteria = questionType === 'subjective'
        ? ((parsed.criteria || []).length ? parsed.criteria : [createEmptyCriterion()])
        : [];
      return {
        ...previous,
        id: previous.id || munNo,
        munNo,
        dap: questionType === 'subjective' ? '' : String(parsed.answer || ''),
        point: Number(parsed.point) > 0 ? String(parsed.point) : (previous.point || ''),
        analysisItem: parsed.analysisItem || '',
        questionType,
        criteria,
        modelAnswerText: questionType === 'subjective' ? String(parsed.modelAnswerText || '') : '',
        modelAnswerImageKey: '',
        modelAnswerImageName: '',
        modelAnswerPreview: '',
        modelAnswerStatus: 'idle',
        modelAnswerError: parsed.warning || '',
        modelAnswerConfidence: parsed.confidence,
        isModelAnswerEditing: false
      };
    });

    setQuestionCount(nextQuestionCount);
    setSelectedValues(nextSelectedValues);
    setList(nextList);
    setPointSum(nextList.reduce((sum, item) => sum + (Number(item.point) || 0), 0));
};

const uploadModelAnswerSheet = async (sourceFile) => {
    if (!sourceFile || !['image/jpeg', 'image/png', 'image/webp'].includes(sourceFile.type)) {
      setModelAnswerSheet((current) => ({ ...current, error: 'JPG, PNG 또는 WEBP 이미지를 사용하세요.' }));
      return;
    }

    const previousSheet = modelAnswerSheet;
    let previewUrl = '';
    let aiCompleted = false;
    try {
      setModelAnswerSheet((current) => ({ ...current, status: 'analyzing', error: '' }));
      const file = await prepareFullSheetImage(sourceFile);
      previewUrl = URL.createObjectURL(file);
      setModelAnswerSheet((current) => ({ ...current, previewUrl, status: 'analyzing', error: '' }));
      const dataUrl = await fileToDataUrl(file);
      const analysisResponse = await submitBilledAi(
        '/convert/lmsTec/omrModelAnswerSheet', 'teacher_omr_sheet_extract',
        { image: dataUrl.split(',')[1], type: file.type },
        { timeout: 120000 }
      );
      aiCompleted = true;
      if (String(previousSheet.previewUrl || '').startsWith('blob:')) URL.revokeObjectURL(previousSheet.previewUrl);
      const parsedQuestions = Array.isArray(analysisResponse.data?.questions) ? analysisResponse.data.questions : [];
      applyModelAnswerSheetQuestions(parsedQuestions);
      const questionWarnings = parsedQuestions
        .filter((item) => item?.warning)
        .map((item) => `${item.questionNo}번: ${item.warning}`);
      setModelAnswerSheet({
        imageKey: '',
        imageName: file.name || '',
        previewUrl,
        status: 'uploading',
        error: '',
        confidence: Number(analysisResponse.data?.confidence) || 0,
        warnings: [
          ...(Array.isArray(analysisResponse.data?.warnings) ? analysisResponse.data.warnings : []),
          ...questionWarnings
        ].slice(0, 12)
      });
      const acaCode = fnc.getCookie('acaCode');
      const safeParentCode = String(lmsListCode || 'omr').replace(/[^a-zA-Z0-9_-]/g, '_');
      const extensionByType = {
        'image/jpeg': 'jpg',
        'image/png': 'png',
        'image/webp': 'webp'
      };
      const extension = extensionByType[file.type] || 'png';
      const storedFileName = `model-answer-sheet-${Date.now()}.${extension}`;
      const folder = `web/kuesbLmsOmr/model-answer-sheet/${acaCode}/${safeParentCode}`;
      const uploadResponse = await axios.post(
        `${process.env.REACT_APP_SERVER_URL || ''}/generate-upload-url`,
        { fileName: storedFileName, fileType: file.type, folder, sec: 600 }
      );
      if (!uploadResponse.data?.url || !uploadResponse.data?.key) {
        throw new Error('전체 모범답안 이미지 저장 경로를 만들지 못했습니다.');
      }
      await axios.put(uploadResponse.data.url, file, {
        headers: { 'Content-Type': file.type },
        timeout: 120000
      });
      setModelAnswerSheet((current) => ({
        ...current,
        imageKey: uploadResponse.data.key,
        imageName: file.name || storedFileName,
        status: 'success',
        error: ''
      }));
    } catch (error) {
      if (!aiCompleted && previewUrl) URL.revokeObjectURL(previewUrl);
      setModelAnswerSheet((current) => ({
        ...(aiCompleted ? current : previousSheet),
        status: 'error',
        error: aiCompleted ? AI_IMAGE_UPLOAD_ERROR : billingError(error)
      }));
    }
};

const handleModelAnswerSheetPaste = (event) => {
    const imageItem = Array.from(event.clipboardData?.items || [])
      .find((item) => item.kind === 'file' && item.type.startsWith('image/'));
    if (!imageItem) return;
    event.preventDefault();
    const confirmed = window.confirm(
      '전체 모범답안지 이미지를 붙여 넣으면 판독 결과가 현재 문항 설정과 채점 기준에 반영됩니다.\n기존 설정은 자동으로 되돌릴 수 없습니다. 계속하시겠습니까?'
    );
    if (!confirmed) return;
    uploadModelAnswerSheet(imageItem.getAsFile());
};

const handleModelAnswerSheetFile = (event) => {
    const input = event.currentTarget;
    const file = input.files?.[0];
    input.value = '';
    if (file) uploadModelAnswerSheet(file);
};

const clearModelAnswerSheet = () => {
    setModelAnswerSheet((current) => {
      if (String(current.previewUrl || '').startsWith('blob:')) URL.revokeObjectURL(current.previewUrl);
      return createEmptyModelAnswerSheet();
    });
};




  //============================================================================
  return (
    true && (
        <div className='Detail_omrTec'>
            <div className='wrap-main'>
                <div className="title">OMR 만들기 배점: {pointSum}</div>
                <span>점수합계가 100점이 아니어도 가중치 점수 환산으로 100점 처리 됩니다. </span>
                <section
                  className="model-answer-sheet"
                  onPaste={handleModelAnswerSheetPaste}
                >
                  <div className="model-answer-sheet__header">
                    <div>
                      <strong>전체 모범답안지 이미지</strong>
                      <p>표 한 장을 올리면 번호·정답·배점·형식·영역·서술형 풀이·채점기준을 읽어 아래 문항에 자동 입력합니다.</p>
                    </div>
                    {modelAnswerSheet.imageKey && <span>저장 준비 완료</span>}
                  </div>
                  <p className="omr-ai-credit-notice">{AI_CREDIT_NOTICE}</p>
                  <div className="model-answer-sheet__content">
                    <div className="model-answer-sheet__paste-zone" tabIndex="0">
                      {modelAnswerSheet.previewUrl ? (
                        <img src={modelAnswerSheet.previewUrl} alt="전체 모범답안지 미리보기" />
                      ) : (
                        <div>
                          <strong>이곳을 클릭한 후 Ctrl+V</strong>
                          <span>모범답안지 전체 이미지를 붙여 넣으세요.</span>
                        </div>
                      )}
                    </div>
                    <div className="model-answer-sheet__actions">
                      <label>
                        {modelAnswerSheet.previewUrl ? '다른 이미지 선택' : '전체 이미지 선택'}
                        <input
                          type="file"
                          accept="image/jpeg,image/png,image/webp"
                          onChange={handleModelAnswerSheetFile}
                          disabled={modelAnswerSheet.status === 'uploading' || modelAnswerSheet.status === 'analyzing'}
                        />
                      </label>
                      {modelAnswerSheet.previewUrl && (
                        <button
                          type="button"
                          onClick={clearModelAnswerSheet}
                          disabled={modelAnswerSheet.status === 'uploading' || modelAnswerSheet.status === 'analyzing'}
                        >
                          이미지 제거
                        </button>
                      )}
                    </div>
                  </div>
                  <p className={`model-answer-sheet__status ${modelAnswerSheet.error ? 'error' : ''}`}>
                    {modelAnswerSheet.status === 'uploading'
                      ? '전체 모범답안 이미지를 저장하고 있습니다…'
                      : modelAnswerSheet.status === 'analyzing'
                        ? 'AI가 표를 읽어 문항별 정답과 설정을 자동 입력하고 있습니다…'
                      : modelAnswerSheet.error
                        ? modelAnswerSheet.error
                        : modelAnswerSheet.imageKey
                          ? `자동 입력 완료${modelAnswerSheet.confidence ? ` · 판독 신뢰도 ${modelAnswerSheet.confidence}%` : ''} · 원본 이미지도 채점에 사용됩니다.`
                          : '이미지의 표를 자동 입력하고 원본 이미지 자체도 AI 채점에 사용합니다.'}
                  </p>
                  {modelAnswerSheet.warnings?.length > 0 && (
                    <ul className="model-answer-sheet__warnings">
                      {modelAnswerSheet.warnings.map((warning, index) => <li key={index}>{warning}</li>)}
                    </ul>
                  )}
                </section>
                <table className="warp-marking-omr">
                    <tbody>
                        {list.map((item, index) => (
                            <tr className={`tr_queMenu_omr ${item.questionType === 'subjective' ? 'subjective' : ''}`} key={index}>
                                <td>
                                    <div className="question-main">
                                      <span className="NoOmr">{index + 1}</span>
                                      {item.questionType === 'objective' && (
                                        <>
                                          {[1, 2, 3, 4, 5].map((value) => (
                                              <label
                                                  key={value}
                                                  className={`custom-radio ${selectedValues[index + 1] == value ? 'selected' : ''}`}
                                                  data-number={value}
                                              >
                                                  <input
                                                      type="radio"
                                                      name={`question${index + 1}`}
                                                      value={value}
                                                      checked={selectedValues[index + 1] == value}
                                                      onChange={() => handleRadioChange(index, value)}
                                                  />
                                              </label>
                                          ))}

                                        </>
                                      )}

                                      {item.questionType === 'objective' && (
                                        <input
                                            className="markingValue_omr"
                                            type="text"
                                            spellCheck="false"
                                            autoComplete="off"
                                            placeholder=""
                                            value={selectedValues[index + 1] || ''}
                                            onChange={(e) => handleRadioChange(index, e.target.value)}
                                        />
                                      )}

                                      {item.questionType === 'shortAnswer' && (
                                        <div className="short-answer-editor">
                                          {item.isShortAnswerEditing || !String(selectedValues[index + 1] || '').trim() ? (
                                            <input
                                                className="markingValue_omr short-answer"
                                                type="text"
                                                spellCheck="false"
                                                autoComplete="off"
                                                autoFocus={Boolean(item.isShortAnswerEditing)}
                                                placeholder="단답형 정답 (예: 20, teacher)"
                                                value={selectedValues[index + 1] || ''}
                                                onChange={(e) => {
                                                  handleRadioChange(index, e.target.value);
                                                  updateModelAnswer(index, { isShortAnswerEditing: true });
                                                }}
                                            />
                                          ) : (
                                            <div className="short-answer-katex-preview">
                                              <KatexText value={formatShortAnswerForKatex(selectedValues[index + 1])} />
                                            </div>
                                          )}
                                          {String(selectedValues[index + 1] || '').trim() && (
                                            <button
                                              type="button"
                                              className="short-answer-preview-toggle"
                                              onClick={() => updateModelAnswer(index, {
                                                isShortAnswerEditing: !item.isShortAnswerEditing
                                              })}
                                            >
                                              {item.isShortAnswerEditing ? 'KaTeX로 보기' : '원문 수정'}
                                            </button>
                                          )}
                                        </div>
                                      )}

                                      <div className='question-type'>
                                        <ComboboxMui
                                          label=""
                                          value={item.questionType || 'objective'}
                                          onChange={(event) => handleQuestionTypeChange(event, index)}
                                          options={optionData_questionType}
                                        />
                                      </div>

                                      <div className='point'>
                                        <ComboboxMui
                                          label=""
                                          value={item.point || ''}
                                          onChange={(event) => handleOptionChange(event, index)}
                                          options={optionData}
                                        />
                                      </div>

                                      <div className='analysis'>
                                        <ComboboxMui
                                          label=""
                                          value={item.analysisItem || ''}
                                          onChange={(event) => handleOptionChange_analysis(event, index)}
                                          options={optionData_analysis}
                                        />
                                      </div>
                                    </div>

                                    {item.questionType === 'subjective' && (
                                      <div className="rubric-editor">
                                        <div className="rubric-header">
                                          <span>채점 기준</span>
                                          <button type="button" onClick={() => addCriterion(index)}>+기준 추가</button>
                                        </div>
                                        {(item.criteria || []).map((criterion, criterionIndex) => (
                                          <div className="rubric-row" key={criterionIndex}>
                                            <span className="criterion-number">{criterionIndex + 1}</span>
                                            <input
                                              className="criterion-text"
                                              type="text"
                                              placeholder="AI가 확인할 채점 기준을 입력하세요."
                                              value={criterion.text}
                                              onChange={(event) => handleCriterionChange(index, criterionIndex, 'text', event.target.value)}
                                            />
                                            <div className="criterion-type">
                                              <ComboboxMui
                                                label=""
                                                value={criterion.valueType}
                                                onChange={(event) => handleCriterionChange(index, criterionIndex, 'valueType', event.target.value)}
                                                options={optionData_valueType}
                                              />
                                            </div>
                                            <input
                                              className="criterion-value"
                                              type="number"
                                              min="0"
                                              step="0.1"
                                              placeholder={criterion.valueType === 'ratio' ? '배율' : '점수'}
                                              value={criterion.value}
                                              onChange={(event) => handleCriterionChange(index, criterionIndex, 'value', event.target.value)}
                                            />
                                            <button
                                              type="button"
                                              className="criterion-remove"
                                              onClick={() => removeCriterion(index, criterionIndex)}
                                              aria-label={`${criterionIndex + 1}번 채점 기준 삭제`}
                                            >
                                              삭제
                                            </button>
                                          </div>
                                        ))}

                                        {modelAnswerSheet.imageKey && item.modelAnswerText && (
                                          <div className="model-answer-sheet-linked">
                                            <div className="model-answer-sheet-linked__katex">
                                              <KatexText value={item.modelAnswerText} />
                                            </div>
                                          </div>
                                        )}
                                        {!modelAnswerSheet.imageKey && (
                                          <div
                                            className="model-answer-editor"
                                            onPaste={(event) => handleModelAnswerPaste(index, event)}
                                          >
                                          <div className="model-answer-header">
                                            <strong>모범 답안</strong>
                                            <span>이미지를 붙여 넣으면 KaTeX 수식으로 변환됩니다.</span>
                                          </div>
                                          <p className="omr-ai-credit-notice">{AI_CREDIT_NOTICE}</p>
                                          <div className="model-answer-content">
                                            <div className="model-answer-paste-zone" tabIndex="0">
                                              {item.modelAnswerPreview ? (
                                                <img src={item.modelAnswerPreview} alt={`${index + 1}번 모범 답안 원본`} />
                                              ) : (
                                                <span>이곳을 클릭한 후 Ctrl+V</span>
                                              )}
                                              <label>
                                                이미지 선택
                                                <input
                                                  type="file"
                                                  accept="image/jpeg,image/png,image/webp"
                                                  onChange={(event) => handleModelAnswerFile(index, event)}
                                                  disabled={item.modelAnswerStatus === 'converting' || item.modelAnswerStatus === 'uploading'}
                                                />
                                              </label>
                                            </div>
                                            <div className="model-answer-text-wrap">
                                              {item.isModelAnswerEditing ? (
                                                <textarea
                                                  value={item.modelAnswerText || ''}
                                                  onChange={(event) => updateModelAnswer(index, {
                                                    modelAnswerText: event.target.value,
                                                    modelAnswerError: ''
                                                  })}
                                                  maxLength="16000"
                                                  rows="7"
                                                  autoFocus
                                                  placeholder="모범 답안을 입력하세요. 수식은 $...$ 또는 $$...$$로 작성합니다."
                                                  disabled={item.modelAnswerStatus === 'converting'}
                                                />
                                              ) : item.modelAnswerText ? (
                                                <div className="model-answer-katex-preview">
                                                  <KatexText value={item.modelAnswerText} />
                                                </div>
                                              ) : (
                                                <div className="model-answer-empty">
                                                  이미지를 붙여 넣으면 변환된 모범 답안이 여기에 표시됩니다.
                                                </div>
                                              )}
                                              <div className="model-answer-meta">
                                                <span>
                                                  {item.modelAnswerStatus === 'converting'
                                                    ? '이미지 판독·변환 중…'
                                                    : item.modelAnswerStatus === 'uploading'
                                                      ? '변환 완료 · 이미지 저장 중…'
                                                    : item.modelAnswerStatus === 'success'
                                                      ? `변환 완료${item.modelAnswerConfidence ? ` · 신뢰도 ${item.modelAnswerConfidence}%` : ''}`
                                                      : item.modelAnswerStatus === 'uploadError'
                                                        ? '판독 완료 · 이미지 저장 실패'
                                                      : item.modelAnswerStatus === 'error'
                                                        ? '변환 실패 · 아래 오류를 확인하세요.'
                                                        : item.modelAnswerText ? 'KaTeX 미리보기' : '모범 답안 없음'}
                                                </span>
                                                <div>
                                                  <button
                                                    type="button"
                                                    onClick={() => updateModelAnswer(index, {
                                                      isModelAnswerEditing: !item.isModelAnswerEditing
                                                    })}
                                                    disabled={item.modelAnswerStatus === 'converting' || item.modelAnswerStatus === 'uploading'}
                                                  >
                                                    {item.isModelAnswerEditing ? '미리보기로' : item.modelAnswerText ? '원문 수정' : '직접 입력'}
                                                  </button>
                                                  <button type="button" onClick={() => clearModelAnswer(index)}>내용 삭제</button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                            {item.modelAnswerError && <p className="model-answer-error">{item.modelAnswerError}</p>}
                                          </div>
                                        )}
                                      </div>
                                    )}
                                   
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

                      
          <section className='section-menu-omr'>
            <div className='omr-main-actions'>
              <input className='txtMunCnt' type='text' placeholder='문항수를 입력하세요'
                value={questionCount || ''}
                onChange={handleMunCntChange} />
              <Button className='btnMakeOmr' onClick={onMakeOmr}>OMR만들기</Button>
              <Button className='btnSave' onClick={onSave}>저장</Button>
              <Button className='btnDelete' onClick={onDelete}>삭제</Button>
              <Button className='btnRefresh' onClick={onRefresh}>새로고침</Button>
              <Button
                className='btnSubmissionResults'
                onClick={() => setIsSubmissionModalOpen(true)}
                disabled={!lmsListCode}
              >
                제출 결과
              </Button>
            </div>
            <div className='omr-score-actions'>
              <Button className='btnScore' onClick={() => handleSetAllPoints('2')}>전체 2점</Button>
              <Button className='btnScore' onClick={() => handleSetAllPoints('3')}>3점</Button>
              <Button className='btnScore' onClick={() => handleSetAllPoints('4')}>4점</Button>
              <Button className='btnScore' onClick={() => handleSetAllPoints('5')}>5점</Button>
              <Button className='btnScore' onClick={() => handleSetAllPoints('10')}>10점</Button>
            </div>
          </section>

          {isSubmissionModalOpen && (
            <OmrSubmissionResultsModal
              parentCode={lmsListCode}
              questions={list}
              onClose={() => setIsSubmissionModalOpen(false)}
            />
          )}

        </div>
    )
);
};

export default Detail_omrTec;
